import styles from './index.module.scss';
import ExchangeIcon from 'assets/icons/ExchangeIcon';
import { useMemoTranslations } from 'hooks/Intl';
import * as translations from 'intls/medicine';
import Button from 'components/Button';
import { useState } from 'react';
import EquivalencyList from './EquivalencyList';
import Typography from 'components/Typography';
import Information from './Information';
import InformationIcon from 'assets/icons/InformationIcon';

interface MedicineItemProps {
  medicine: Medicine;
}

type ContentType = '' | 'EQUIVALENCY_LIST' | 'INFORMATION';

const MedicineItem = ({ medicine }: MedicineItemProps) => {
  const intl = useMemoTranslations(translations);

  const [contentType, setContentType] = useState<ContentType>('');

  const changeContentType = (type: ContentType) =>
    setContentType(currentType => (currentType === type ? '' : type));

  return (
    <div key={medicine.medicine_id} className={styles.container}>
      <div className={styles.header}>
        <Typography type="h6" color="subtitle" weight="semibold">
          {medicine.local_name}
        </Typography>
        <div className={styles.buttonsContainer}>
          <Button
            type="PrimaryWithoutBorder"
            onClick={() => changeContentType('EQUIVALENCY_LIST')}
            className={styles.optionButton}
          >
            <span className={styles.optionButtonContent}>
              {intl.EQUIVALENT_BRANDS}
              <ExchangeIcon />
            </span>
          </Button>
          <Button
            type="PrimaryWithoutBorder"
            onClick={() => changeContentType('INFORMATION')}
            className={styles.optionButton}
          >
            <span className={styles.optionButtonContent}>
              {intl.MEDICINE_INFORMATION}
              <InformationIcon />
            </span>
          </Button>
        </div>
      </div>
      {contentType === 'EQUIVALENCY_LIST' && (
        <EquivalencyList medicine={medicine} />
      )}
      {contentType === 'INFORMATION' && <Information medicine={medicine} />}
    </div>
  );
};

export default MedicineItem;
